import createAssetFromDescriptor from './createAssetFromDescriptor';
import documentToPageCoordinates from './documentToPageCoordinates';
import getNextAvailableAssetSpace from './getNextAvailableAssetSpace';
import { isCurrentCultureRightToLeft } from 'owa-localize';
import { ASSUMED_ASSET_WIDTH, TOP_MARGIN, LEFT_MARGIN } from 'owa-timestream-asset-sdk';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import type { ActionSource } from 'owa-timestream-store';
import getCanvasDocumentBounds from './getCanvasDocumentBounds';

export default function createAssetFromClick(
    e: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
    assetDescriptor: AssetDescriptor,
    actionSource: ActionSource
) {
    let bestPosition = getNextAvailableAssetSpace(assetDescriptor);

    if (bestPosition) {
        const xOffset = 0;
        const yOffset = 0;
        const { pageX, pageY } = documentToPageCoordinates(bestPosition.x, bestPosition.y);

        createAssetFromDescriptor(actionSource, assetDescriptor, pageX, pageY, xOffset, yOffset);
    } else {
        const isRTL = isCurrentCultureRightToLeft();
        const xOffset = isRTL ? -ASSUMED_ASSET_WIDTH : LEFT_MARGIN;
        const yOffset = TOP_MARGIN;
        const canvasDocumentBounds = getCanvasDocumentBounds();
        const assetYPlacement = isRTL
            ? canvasDocumentBounds.canvasRight
            : canvasDocumentBounds.canvasLeft;
        const { pageX, pageY } = documentToPageCoordinates(
            assetYPlacement,
            canvasDocumentBounds.canvasTop
        );

        createAssetFromDescriptor(actionSource, assetDescriptor, pageX, pageY, xOffset, yOffset);
    }
}
